import { combineReducers, configureStore } from '@reduxjs/toolkit'
import appReducer from './appSlice'
import campaignLimitReducer, { campaignLimitDefaultState } from './campaignLimitSlice'
import chatReducer from './chatSlice'
import codeReducer from './codeSlice'
import connectionReducer, { connectionDefaultState } from './connectionSlice'
import containerReducer from './containerSlice'
import conversationReducer from './conversationSlice'
import dirHandleReducer, { dirHandleDefaultState, setDirHandleStore } from './dirHandleSlice'
import editorReducer from './editorSlice'
import errorsReducer from './errorsSlice'
import fileExplorerReducer from './fileExplorerSlice'
import flashMessageReducer from './flashMessageSlice'
import flowReducer from './flowSlice'
import galleryScreenReducer from './galleryScreenSlice'
import integrationTestFlowReducer from './integrationTestFlowSlice'
import modalsReducer from './modalSlice'
import pageReducer from './pageSlice'
import settingReducer, { settingsDefaultState } from './settingsSlice'
import taskFormReducer from './taskFormSlice'
import tutorialReducer, { tutorialDefaultState } from './tutorialSlice'
import { loadStateFromLocalStorage, localStorageMiddleware } from './utils'

export const rootReducer = combineReducers({
  app: appReducer,
  conversation: conversationReducer,
  chat: chatReducer,
  code: codeReducer,
  errors: errorsReducer,
  container: containerReducer,
  settings: settingReducer,
  flow: flowReducer,
  fileExplorer: fileExplorerReducer,
  editor: editorReducer,
  flashMessage: flashMessageReducer,
  modals: modalsReducer,
  connection: connectionReducer,
  tutorial: tutorialReducer,
  page: pageReducer,
  taskForm: taskFormReducer,
  galleryScreen: galleryScreenReducer,
  campaignLimit: campaignLimitReducer,
  dirHandle: dirHandleReducer,
  integrationTestFlow: integrationTestFlowReducer
})

const store = configureStore({
  reducer: rootReducer,
  preloadedState: {
    settings: loadStateFromLocalStorage('settings', settingsDefaultState),
    connection: loadStateFromLocalStorage('connection', connectionDefaultState),
    tutorial: loadStateFromLocalStorage('tutorial', tutorialDefaultState),
    campaignLimit: loadStateFromLocalStorage('campaignLimit', campaignLimitDefaultState),
    dirHandle: loadStateFromLocalStorage('dirHandle', dirHandleDefaultState)
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat([
      localStorageMiddleware('settings'),
      localStorageMiddleware('connection'),
      localStorageMiddleware('tutorial'),
      localStorageMiddleware('campaignLimit'),
      localStorageMiddleware('dirHandle'),
      localStorageMiddleware('agentic')
    ])
})

// Inject store into dirHandleSlice to avoid circular dependency
setDirHandleStore(store)

// Deferred store injection for i18n to avoid circular dependency
// This runs after the current event loop completes, after all module imports are done
setTimeout(() => {
  import('~/i18n').then(({ setI18nStore }) => {
    setI18nStore(store)
  })
}, 0)

export type RootState = ReturnType<typeof store.getState>
export type AppStore = typeof store
export type AppDispatch = typeof store.dispatch

export default store
